/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import axios from 'axios';
import { PROJECT_CLOSEOUT_FORM } from '../mutation-types';
import projectCloseoutApi from '../../services/api/projectCloseout.api';
import projectCloseoutService from '../../services/projectCloseout.service';
import { setState } from '../mutationHelpers';
import { ProjectCloseoutStorePayload } from '../../models';

const namespaced = true;

const state = {
  formFields: {
    projectName: '',
    projectNumber: '',
    companyCity: '',
    contactCountry: '',
    contactState: '',
    projectCompletionDate: null,
    estimatedCompletionDate: null,
    finalContractAmount: null,
    yourCompanyName: '',
    closeoutInformation: '',
    submitterEmail: '',
  } as ProjectCloseoutStorePayload,
  currentPage: 1,
  countryOptions: [],
  submitting: false,
  submitted: false,
};

const getters = {
  countryOptions: storeState => storeState.countryOptions,
  stateProvinceOptions: storeState => countryName => (storeState.countryOptions.find(x => x.name === countryName) ? storeState.countryOptions.find(x => x.name === countryName).stateProvinces : []),
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [PROJECT_CLOSEOUT_FORM.UPDATE_COUNTRY_OPTIONS]: setState('countryOptions'),
  [PROJECT_CLOSEOUT_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [PROJECT_CLOSEOUT_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [PROJECT_CLOSEOUT_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [PROJECT_CLOSEOUT_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },
};

const actions = {
  goToNextPage({ commit, state: actionState }) {
    commit(PROJECT_CLOSEOUT_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit, state: actionState }) {
    commit(PROJECT_CLOSEOUT_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage - 1);
    window.scrollTo(0, 0);
  },

  async getCountries({ commit }) {
    const { data } = await axios.get('/api/countries');
    commit(PROJECT_CLOSEOUT_FORM.UPDATE_COUNTRY_OPTIONS, data);
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(PROJECT_CLOSEOUT_FORM.TOGGLE_SUBMITTING_STATE, true);
      const createPayload = projectCloseoutService.buildCreatePayload(actionState.formFields);
      try {
        await projectCloseoutApi.create(createPayload);
        commit(PROJECT_CLOSEOUT_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Project Closeout - Submitted',
            page_path: '/forms/project-closeout/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(PROJECT_CLOSEOUT_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};